export default "__VITE_ASSET__07d4628b__"